import React, { useState } from "react";
import {
  Grid,
  Select,
  MenuItem,
  IconButton
} from "@material-ui/core";
import ChevronRight from "@material-ui/icons/ChevronRight";
import { useHistory } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles(theme => ({
  selectorContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    "& .MuiFilledInput-input": {
      backgroundColor: "transparent",
      padding: '18px 12px 10px'
    },
    "& .MuiSelect-root": {
      borderRadius: '1em'
    },
  },
  actionUserSelection: {
    border: '1px solid',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    '&:hover':{
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
    padding: '0.5em',
    margin: 'auto',
    fontSize: '0.5em',
    marginLeft: '0.5em'
  }
}));


function UserSelectionField(props){
  const courseId = props.courseId;
  const courseName = props.courseName;
  const page = props.page;
  const roles = [
    {value: 'Student', label: 'Staff/Student'},
    {value: 'Educator', label: 'Managers/Educators'},
  ];
  const classes = useStyles();
  const [selectedRole, setSelectedRole] = useState('Student');
  let history = useHistory();  

  const handleButtonClick = () => {
    history.push({
      pathname: `/dashboard/courses/${courseId}/user-selection`,
      search: `?courseName=${courseName}&role=${selectedRole}&action=View&listPage=${page}`,  // query string
      state: {  // location state
        update: true, 
      },
    }); 
  }

  const handleChange = (event) => {
    setSelectedRole(event.target.value);
  }

  return (
    <div className='user-selection'>
      <Grid container spacing={3} direction="row">
        <Grid item xs={2}>
          <h3> Users </h3>
        </Grid>
        <Grid item xs={10}>          
          <div className={classes.selectorContainer}>
            <Select id="demo-simple-select-helper" multiple={false} value={selectedRole} variant="outlined" fullWidth={true} displayEmpty onChange={handleChange} >
              {roles.map(item => (
                <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
              ))}
            </Select>   
            <IconButton onClick={handleButtonClick} className={classes.actionUserSelection} fontSize="small" aria-label="View users">
              <ChevronRight />
            </IconButton>         
          </div>
        </Grid>
      </Grid>
    </div>
  )

}

export default UserSelectionField;